"use strict";

import angular from "angular";

import template from "./chart-with-input.component.html";
import "./themes/chart-with-input.component.scss";

import _ from "lodash";
import { Available } from "../../../gateway/Available/Available";
import { Company } from "../../../gateway/Company/Company";
import { Point } from "../../../gateway/Point/Point";
import { ColorService } from "../../../presentation/services/ColorService/ColorService";
import { GetCompaniesByIdsAndFilterUsecase } from "../../../usecases/get-companies-by-ids-and-filter.usecase";
import { FormatNumbers } from "../../../utils/format-numbers";
import historicValuesDialogTemplate from "../../dialogs/historic-values/historic-values-dialog.html";
import infoVisualizationDialogTemplate from "../../../views/accounting/company/customization/dashboards/info-visualization/info-visualization-dialog.html";
class ChartWithInputComponent {
    isGroup = false;
    constructor(
        $rootScope,
        $state,
        ThemesService,
        LoaderService,
        DSNDialogService,
        $scope
    ) {
        this.$rootScope = $rootScope;

        this.LoaderService = LoaderService;
        this.DSNDialogService = DSNDialogService;
        this.$scope = $scope;

        this.inputValue = 0;
        this.visualization = {};
        this.title = "Saldo Inicial de Caixa";

        this.Company = new Company();
        this.Point = new Point();
        this.Available = new Available();
        this.ColorService = new ColorService({ ThemesService: ThemesService });

        this.companyId = $state.params.id;
        this.company = {};
    }

    $onInit() {
        this._setCompany();
        const isGroup = this.companyData?.isGroup;

        this.isGroup = isGroup;

        this._setStructure();
    }

    $onChanges(changes) {
        if (!_.isEmpty(_.get(changes, "currentPeriod.previousValue") || {})) {
            this._setInputValue();
        }
    }

    _setStructure() {
        const color = this.ColorService.colorByPath(this.configs.colors);

        const getSeriesReference = () => {
            return this.visualizationData.series.map((serieId) => {
                return {
                    _id: serieId,
                    color: color
                };
            });
        };
        const series = getSeriesReference();
        const configs = {
            chart: {
                category: "column",
                plotOptions: {
                    borderWidth: 0,
                    series: {
                        marker: {
                            enabled: true,
                            radius: 2
                        },
                        animation: {
                            duration: 1000
                        },

                        states: {
                            hover: {
                                enabled: true,
                                fillOpacity: 1
                            }
                        },
                        color: color
                    }
                },
                series,
                chart: {
                    reflow: true,
                    type: "column"
                },
                legend: {
                    enabled: false
                },
                yAxis: {
                    title: {
                        enabled: false
                    },
                    plotLines: [
                        {
                            zIndex: 6
                        }
                    ],
                    labels: {
                        enabled: true
                    }
                }
            }
        };
        if (this.goals && this.visualizationData?.goals?.length) {
            configs.chart.goals = this.visualizationData.goals.map((goal) => {
                return { _id: goal.r, color: "basic.light" };
            });
        }

        configs.chart.tooltip = this.getTooltip();
        this.visualization = configs;
    }

    async _setCompany() {
        const getCompaniesByIdsAndFilterUsecase = new GetCompaniesByIdsAndFilterUsecase();
        try {
            const companies = await getCompaniesByIdsAndFilterUsecase.execute({
                companyIds: [this.companyId]
            });
            this.company = companies?.[0] || {};
            this._setInputValue();
        } catch (error) {
            this.company = {};
            this._setInputValue();
            console.error(
                "Erro ao carregar empresa no chart-with-input:",
                error
            );
        }
        if (this.$scope?.$applyAsync) {
            this.$scope.$applyAsync();
        }
    }

    _setInputValue() {
        const year = this.currentPeriod.date.getFullYear();

        const scenario =
            "ORIGINAL" || _.get(this.currentPeriod, "scenario._id");

        this.inputValue =
            _.get(this.company, `cashBalance[${year}][${scenario}]`) || 0;
    }

    async onUpdateCashBalance(yearsChanged = []) {
        this.loading = true;
        this.LoaderService.setProgress(true);
        const year = this.currentPeriod.date.getFullYear();

        if (!yearsChanged.length) yearsChanged.push(year);

        const scenario =
            _.get(this.currentPeriod, "scenario._id") || "ORIGINAL";

        if (!this.company?.cashBalance) this.company.cashBalance = {};

        _.set(
            this.company,
            `cashBalance[${year}][${scenario}]`,
            this.inputValue
        );

        const fields = {
            cashBalance: this.company.cashBalance
        };

        await this.Company.updateFields(
            this.company.accountingId,
            this.company._id,
            fields
        );

        for (const yearValue of yearsChanged) {
            this._updatePoint({
                year: yearValue,
                scenarioId: scenario,
                value: _.get(
                    this.company,
                    `cashBalance[${yearValue}][${scenario}]`
                )
            });
        }

        this.refreshData();

        this.$rootScope.$broadcast("REFRESH_DRILL_DOWN");

        this.LoaderService.setProgress(false);
        this.loading = false;
    }

    _updatePoint({ year, scenarioId, value }) {
        this.Point.deleteMany({
            s: "CASH_BALANCE",
            t: parseInt(year),
            sc: scenarioId
        });

        const point = {
            s: "CASH_BALANCE",
            t: parseInt(year),
            sc: scenarioId,
            m: { v: value },
            c: this.companyId
        };

        this.Point.create(point);
    }

    onClickHistoric(ev) {
        const scenarioId = "ORIGINAL";
        // _.get(this.currentPeriod, "scenario._id") || "";

        this.DSNDialogService.custom({
            targetEvent: ev,
            controller: "HistoricValuesDialogCtrl",
            controllerAs: "$ctrl",
            locals: {
                width: "285px",
                templateHtml: historicValuesDialogTemplate,
                title: "Histórico de Saldos",
                scenarioId,
                cashBalance: this.company.cashBalance,
                yearsAvailable: this.Available.getYears(this.companyId, "fin")
            },
            after: {
                hide: ({ cashBalance, yearsChanged }) => {
                    this.company.cashBalance = cashBalance;
                    this._setInputValue();
                    this.onUpdateCashBalance(yearsChanged);
                },
                cancel: () => {}
            }
        });
    }

    onSelectInfoVisualization() {
        this.DSNDialogService.custom({
            clickOutsideToClose: true,
            locals: {
                templateHtml: infoVisualizationDialogTemplate,
                title: `Conheça o indicador de ${this.title}`,
                width: "40vw",
                description: `<p>"Saldo Inicial de Caixa são os valores anteriores ao início da gestão financeira da empresa a qual não possuem detalhes da distribuição de valores"</p><p>O usuário pode informar manualmente esse valor, a qual será adicionado ou subtraído da variação de caixa acumulada.</p><p>A Nucont por padrão mantém os valores acumulados até Dezembro de cada ano. Caso o usuário deseje manter a acumulação, deverá adicionar saldo inicial no segundo ano de dados e assim continuamente.</p>`
            },
            after: {}
        });
    }

    getTooltip() {
        const formatNumbers = FormatNumbers;
        return {
            headerFormat: "<b>{point.key}</b><br>",
            pointFormatter: function () {
                const pointFormatted = formatNumbers.byUnit(
                    this.series.userOptions.unit,
                    this.y,
                    1
                );

                return (
                    `<div width="20" height="20" style="color:${this.color};">● </div>` +
                    ` ${this.series.name}` +
                    ": " +
                    `<b>${pointFormatted}</b>` +
                    "<br/>"
                );
            },
            xDateFormat: "%B de %Y",
            shared: true
        };
    }
}

ChartWithInputComponent.$inject = [
    "$rootScope",
    "$state",
    "ThemesService",
    "LoaderService",
    "DSNDialogService",
    "$scope"
];

const name = "chartWithInputComponent";
const def = {
    bindings: {
        series: "<",
        configs: "<",
        points: "<",
        currentPeriod: "<",
        currentComparation: "<",
        source: "<",
        refreshData: "&",
        projection: "<",
        budget: "<",
        goals: "<",
        visualizationData: "<",
        companyData: "<"
    },
    controller: ChartWithInputComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
